export default function isQA() {
  return window.location.host.indexOf('hubspotqa') > -1;
}